import axios from "@axios";
import store from "@/store";

export default {
  namespaced: true,
  state: {
    items: [],
    progress: 0,
    error: '',
    url: '',
    isCreatedFile: false
  },
  getters: {
    getItems(state) {
      return state.items;
    },
    getSelectedItems(state) {
      return state.items.map((traffic) => ({
        value: traffic.id,
        label: traffic.request,
      }));
    },
    getProgress(state) {
      return state.progress
    },
    getError(state) {
      return state.error
    },
    getUrl(state) {
      return state.url
    },
  },
  mutations: {
    setData(state, value) {
      state.items = value;
    },
  },
  actions: {
    async getAll({ commit }, params) {
      const response = await axios.get(`${window.__env.VUE_APP_MS_DETECTION_EVENTS_URL}/v2/detection-events`, {
        params
      });

      if (!response.data) {
        return [];
      }
    
      commit("setData", response.data.data);
      return response.data;
    },
    async export({ commit }, params) {
      try {
        console.log(params);
        const response = await axios.get(`${window.__env.VUE_APP_MS_DETECTION_EVENTS_URL}/v2/detection-events/export`, {
          params,
          responseType: 'arraybuffer',
        });
        if (!response.data) {
          return [];
        }
        if (params?.action === 'export') {

          // Create a Blob from the binary response
          const blob = new Blob([response.data], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          });

          // Generate download URL and create a download link
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          
          // Extract filename from headers or fallback
          const filename = response.headers['content-disposition']
            ? response.headers['content-disposition'].split('filename=')[1]
            : 'exported-file.xlsx';

          link.setAttribute('download', filename);

          document.body.appendChild(link);
          link.click();
          link.remove();

          const notification = {
            id: filename,
            progress: 100,
            completed: true,
            view: 'Ms Detection Events',
            url: url,
            download: filename,
            title: 'Ms Detection Events',
            body: 'Descarga completa',
            error: false,
            timestamp: new Date().toLocaleString(),
          };
          store.dispatch('grid/updateDownloadNotification', notification);
        }
        else {
          commit('setData', response.data.data);
          return response.data;
        }
      } catch (error) {
        console.error('Error during export:', error);
        const notification = {
          id: 'error-export',
          progress: 0,
          completed: false,
          view: 'Ms Detection Events',
          title: 'Error en la exportación',
          body: 'Hubo un error al intentar descargar el archivo.',
          error: true,
          timestamp: new Date().toLocaleString(),
        };
        store.dispatch('grid/updateDownloadNotification', notification);
      }
    },
    clear({ commit }) {
      commit("setData", []);
    },
  },
};
